import { ChangeDetectionStrategy, Component } from '@angular/core';

import { PlatformUpdateService } from '@core/services/platform-update.service';
import { environment } from '@env/environment';
import { OverlayContentService } from 'mojo-batch';
import { PDFTooltipService } from '@shared/services/tooltip.service';

@Component({
  selector: 'mojo-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  constructor(
    platformUpdateService: PlatformUpdateService,
    public pdfToolTip: PDFTooltipService,
    public overlayContentService: OverlayContentService,
  ) {
    if (environment.production) {
      platformUpdateService.init();
    }
  }
}
